



import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class ProgressBar extends Vue {
    @Prop()
    public inProgress!: boolean;
}
